import http from '../_http_v2';

const agent = {
  //default
  summary: (m) => { return http.get(`console/wsfinder/agent`, m); },
  list: (m) => { return http.post(`console/wsfinder/agent/list`, m); },
  detail: (m) => { return http.get(`console/wsfinder/agent/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/wsfinder/agent`, m); },
  update: (m) => { return http.put(`console/wsfinder/agent`, m); },
  delete: (m) => { return http.delete(`console/wsfinder/agent/${m.id}`); },

  //other
  apply: (m) => { return http.post(`console/wsfinder/agent/apply`, m); },
  agree: (m) => { return http.get(`console/wsfinder/agent/agree`, m); },
  start: (m) => { return http.get(`console/wsfinder/agent/start/${m.id}`); },
  stop: (m) => { return http.get(`console/wsfinder/agent/stop/${m.id}`); },
  upgrade: (m) => { return http.get(`console/wsfinder/agent/upgrade/${m.id}`); },
}

const WSFinderLatest = (branch='release') => { return http.get(`/${branch}/latest/wsfinder`); }

export default agent

export { agent, WSFinderLatest }